// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"c7b8d3bb","787":"eaaab13d","842":"f94a7823"}[chunkId] + ".chunk.js";
};